import { useMemo } from 'react';
import { useResendConfirmation } from '@dfl/react-security';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';

const useResendClientConfirmation = (onSuccess?: () => void) => {
  const { t } = useTranslation('authentication');

  const config = useMemo(
    () => ({
      onSuccess: () => {
        toast.success(t('confirmation.emailResend'));
        onSuccess?.();
      },
    }),
    [t, onSuccess],
  );

  return useResendConfirmation(config);
};

export default useResendClientConfirmation;
